export default __webpack_public_path__ + "static/ear-white-e2645cce846631524bb217c4695def0b.jpg";